import React from 'react';
import { IPopoverProps, Popover as BlueprintPopover } from '@blueprintjs/core';
import { Popover2 as BlueprintPopover2, Popover2Props as BlueprintPopover2Props } from '@blueprintjs/popover2';

/**
 * @deprecated we need to migrate away from this - use Popover2 instead!
 */
const Popover = (props: IPopoverProps) => <BlueprintPopover {...props} />;

Popover.defaultProps = {
  minimal: true,
  targetTagName: 'div',
  shouldReturnFocusOnClose: true,
  modifiers: {
    offset: {
      enabled: true,
      offset: '0, 4px'
    }
  }
};

const DEFAULT_POPOVER_MODIFIERS: BlueprintPopover2Props['modifiers'] = {
  offset: {
    enabled: true,
    options: {
      offset: [0, 4]
    }
  }
};

export const Popover2 = ({
  minimal = true,
  targetTagName = 'div',
  shouldReturnFocusOnClose = true,
  modifiers = DEFAULT_POPOVER_MODIFIERS,
  ...rest
}: BlueprintPopover2Props) => (
  <BlueprintPopover2
    minimal={minimal}
    targetTagName={targetTagName}
    shouldReturnFocusOnClose={shouldReturnFocusOnClose}
    modifiers={modifiers}
    {...rest}
  />
);

export type Popover2Props = BlueprintPopover2Props;

export default Popover;
